module.exports = __webpack_public_path__ + "img/vhodna.b8bd761b.svg";